// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__24czF","colMaxWidth":"Table_colMaxWidth__1PSmB"};